export enum MoleculorSocketEndpointKey {
  ASSISTANT = 'assistant',
  RATE_MESSAGE = 'assistant.rate-message',
}

export type MoleculorSocketEndpointPayload = {
  [MoleculorSocketEndpointKey.ASSISTANT]: {
    message: { content: string };
    context: {
      relatedEntity?: {
        id?: string;
        type: string | null;
      };
    };
  };
  [MoleculorSocketEndpointKey.RATE_MESSAGE]: {
    messageId: string;
    useful: boolean;
    comment?: string;
  };
};
